module.exports = __webpack_public_path__ + "img/logo_azul.ee3d07af.png";